import React from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';

export function AppLoadingPanel() {
  return (
    <Dimmer active>
      <Loader />
    </Dimmer>
  );
}
